import type { IconData } from '@stacksjs/iconify-core'

export const chevronRight: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m5.314 7.071l-4.95-4.95A1 1 0 0 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default chevronRight
